import Phaser from 'phaser';
import { GAME_CONFIG } from '@/config/game-config';
import { initOrientationDetector } from '@/utils/orientation-detector';

export const game = new Phaser.Game(GAME_CONFIG);

// Initialize mobile orientation detection
initOrientationDetector();
